import { Piece, Position, TeamType, samePosition } from "../../Constants";

export const tileIsOccupied = (
  position: Position,
  boardState: Piece[]
): Boolean => {
  const piece = boardState.find((p) => samePosition(p.position, position));
  if (piece) {
    return true;
  } else {
    return false;
  }
};

export const tileIsEmptyOrOccupiedByOpponent = (
  position: Position,
  boardState: Piece[],
  team: TeamType
) => {
  return (
    !tileIsOccupied(position, boardState) ||
    tileIsOccupiedByOpponent(position, boardState, team)
  );
};

export const tileIsOccupiedByOpponent = (
  position: Position,
  boardState: Piece[],
  team: TeamType
): Boolean => {
  const piece = boardState.find(
    (p) => samePosition(p.position, position) && p.team !== team
  );
  if (piece) {
    return true;
  } else {
    return false;
  }
};
